import React from 'react'
import {Row} from "react-bootstrap";
import 'components/Vote/vote.css';
import CircularProgress from '@mui/material/CircularProgress';
import LoadingPlaceholderBlock from "../common/LoadingPlaceholderBlock";
import styles from "../Message-V2/Styles.module.css"

const MessageLoading = () => {
    return (
        <Row className='position-relative'>
            <LoadingPlaceholderBlock height={'150px'} borderRadius={'3px'}/>
            <div className={styles.msgLoaderContainer}>
                <div className={styles.msgLoaderInner}>
                    <CircularProgress sx={{color: '#003300'}}/>
                </div>
            </div>
        </Row>
    )
}

export { MessageLoading }